var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { GoogleMapComponent } from './../common-theme/gmaps/google-map/google-map.component';
import { InterfaceComponent } from './interface.component';
var GmapComponent = /** @class */ (function (_super) {
    __extends(GmapComponent, _super);
    function GmapComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return GmapComponent;
}(GoogleMapComponent));
export { GmapComponent };



// WEBPACK FOOTER //
// ./src/app/localisation/gmap.component.ts.pre-build-optimizer.js